import { render } from "./BokFooter.vue?vue&type=template&id=fb7acb00"
import script from "./BokFooter.vue?vue&type=script&lang=js"
export * from "./BokFooter.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__